import Datepicker from "react-tailwindcss-datepicker";
import ProductSelect from "../../../components/CDP/Registrations/ProductSelect";
import PlatformSelect from "../../../components/CDP/Registrations/PlatformSelect";

export default function CdpFilterBar({
  title,
  domain,
  platform,
  dateValue,
  onDomainChange,
  onPlatformChange,
  onDateSelect,
  onApply,
  onReset,
}) {
  return (
    <div className="flex flex-wrap items-center justify-between border-b border-gray-200 px-8 py-6 lg:flex-nowrap">
      <div className="mb-4 min-w-full flex-1 lg:mb-0 lg:min-w-0">
        <h2 className="text-lg font-bold text-gray-900 sm:truncate sm:text-2xl sm:tracking-tight">
          {title}
        </h2>
      </div>
      <div className="mt-0 flex w-full flex-wrap items-center md:ml-4 lg:w-auto lg:flex-nowrap">
        <div className="mb-3 mr-0 w-full lg:mb-0 lg:mr-4 lg:w-52">
          <ProductSelect selectedDomain={domain} setSelectedDomain={onDomainChange} />
        </div>
        <div className="mb-3 mr-0 w-full lg:mb-0 lg:mr-4 lg:w-40">
          <PlatformSelect selectedPlatform={platform} setSelectedPlatform={onPlatformChange} />
        </div>
        <div className="mb-3 mr-0 w-full lg:mb-0 lg:mr-4 lg:w-64">
          <div className="rounded-md border border-gray-300 shadow-sm">
            <Datepicker
              primaryColor="red"
              value={dateValue}
              onChange={onDateSelect}
              showShortcuts
              placeholder="Select date..."
            />
          </div>
        </div>
        <div className={`flex w-full ${onReset ? "lg:w-40" : "lg:w-20"}`}>
          <button
            type="button"
            onClick={onApply}
            className="w-full items-center rounded-full bg-red-600 px-5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-red-500"
          >
            Apply
          </button>
          {onReset ? (
            <button
              type="button"
              onClick={onReset}
              className="ms-1 w-auto items-center rounded-full bg-slate-600 px-5 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-slate-700"
            >
              Reset
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
